@if ({ link: navLinks$ | async, deviceType: deviceType$ | async }; as headerNavData) { @if (headerNavData.deviceType ===
'desktop') {
<!-- Desktop View -->
<custom-dot-cms-desktop-view-header-navigation [navLinks]="headerNavData.link" />
} @else {
<custom-dot-cms-general-view-header-navigation [navLinks]="headerNavData.link" />
}
<!-- Mobile and Tablet View -->
}
